import type { ListMonth } from "../flightAirportInterface";

export class ListMonthClass implements ListMonth {
  currency: string = "";

  date: string = "";

  month: string = "";

  percent: number = 0;

  value: number = 0;

  year: number = 0;

  constructor(data?: ListMonth) {
    this.currency = data?.currency ?? this.currency;
    this.date = data?.date ?? this.date;
    this.month = data?.month ?? this.month;
    this.value = data?.value ?? this.value;
    this.year = data?.year ?? this.year;
    this.percent = data?.percent ?? this.percent;
  }
}
